module.exports = __webpack_public_path__ + "static/media/ax.c26f8374.svg";